// REACT_APP_ENV dibaca dari .env / .env.staging / .env.production (lihat package.json
// build:stg, build:prod). Default ke 'development' jika belum diset, supaya perilaku
// lokal tidak berubah sebelum var ini ditambahkan di environment tertentu.
export const APP_ENV = process.env.REACT_APP_ENV || 'development';

// Fitur yang masih POC / dummy data hanya boleh tampil di local development,
// disembunyikan di staging maupun production.
export const isDevOnlyFeatureEnabled = () => APP_ENV === 'development';
